"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomerData = exports.extractRelevantCustomerCustomFields = void 0;
function extractRelevantCustomerCustomFields(custom) {
    if (!custom)
        return undefined;
    return __assign(__assign({}, custom), { fields: {
            sendSubscriptionReminder5Days: custom.fields.sendSubscriptionReminder5Days,
        } });
}
exports.extractRelevantCustomerCustomFields = extractRelevantCustomerCustomFields;
exports.CustomerData = {
    fromCT: function (customer) {
        return {
            custom: extractRelevantCustomerCustomFields(customer.custom),
            email: customer.email,
            externalId: customer.externalId,
            id: customer.id,
            key: customer.key,
            version: customer.version,
        };
    },
};
//# sourceMappingURL=customer.js.map